<ng-container *ngIf="inverded; else notInverted">
  <span [class]="badgeClass" *ngIf="checked" class="badge badge-error">{{ 'Ja' | translate }}</span>
  <span [class]="badgeClass" *ngIf="!checked" class="badge badge-success">{{ 'Nein' | translate }}</span>
</ng-container>
<ng-template #notInverted>
  <span [class]="badgeClass" *ngIf="checked" class="badge badge-success">{{ 'Ja' | translate }}</span>
  <span [class]="badgeClass" *ngIf="!checked" class="badge badge-error">{{ 'Nein' | translate }}</span>
</ng-template>
